import { ElementType, PropsWithChildren, ComponentProps } from "react";

import { css } from "@compiled/react";

export type ContentTextProps<T extends ElementType> = PropsWithChildren &
    ComponentProps<T> & {
        as?: T;
        variant: "md" | "lg" | "xl";
    };

export const ContentText = <T extends ElementType>(
    props: ContentTextProps<T>
) => {
    const { as: Component = "span", variant = "md" } = props;
    return (
        <Component
            {...props}
            css={[
                contentTextCss,
                variant === "xl" && xlCss,
                variant === "lg" && lgCss,
                variant === "md" && mdCss
            ]}
        >
            {props.children}
        </Component>
    );
};

const xlCss = css({
    fontSize: "40px",
    lineHeight: "48px",
    fontWeight: 700
});
const lgCss = css({
    fontSize: "24px",
    lineHeight: "30px",
    fontWeight: 700
});
const mdCss = css({
    fontSize: "14px",
    lineHeight: "20px"
});

const contentTextCss = css({
    fontFamily: "Charlie Text",
    color: "#101214",
    textAlign: "center",
    display: "block",
    margin: 0,
    padding: 0
});
